import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { addAccessorialRate, updateAccessorialRate } from 'utils/AccessorialRatesAPIUtils';
import _ from 'underscore';
import Store from 'stores/AccessorialRatesStore';
import AccessorialRatesEditor from './AccessorialRatesEditor';
import RatesValidator from './RatesValidator';
import Types from './AccessorialRatesTypes';
export default class AccessorialRatesEditModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accessorialRate: props.accessorialRate || this.newAccessorialRate(),
            hasBeenEdited: false,
            valid: false,
        };
        this.onChange = () => this.onStoreChange();
    }
    componentDidMount() {
        Store.addChangeListener(this.onChange);
    }
    componentWillUnmount() {
        Store.removeChangeListener(this.onChange);
    }
    onStoreChange() {
        if (Store.getStatus() === 'success') {
            const propsAccessorialRate = this.props.accessorialRate;
            const storeAccessorialRate = Store.getAccessorialRate();
            if (storeAccessorialRate._id) {
                this.setState({ accessorialRate: _.extend({}, storeAccessorialRate) });
            }
            else {
                this.setState({ accessorialRate: _.extend({}, propsAccessorialRate) });
            }
        }
    }
    newAccessorialRate() {
        return {
            name: '',
            type: 'flatFee',
            rate: 0,
            percent: 0,
            unit: 'day',
            free: 0,
            increment: 0,
            minimum_number: 0,
            minimum_rate: 0,
            maximum_rate: 0,
            over_weight: 0,
            vehicle_rates: [],
            markup: 0,
            special_surcharge: {},
            excludes: [],
            description: '',
            isReady: false,
        };
    }
    close() {
        return () => {
            if (this.props.onClose) {
                this.props.onClose();
            }
        };
    }
    save() {
        return () => {
            if (this.state.accessorialRate) {
                Store.reset();
                addAccessorialRate(this.state.accessorialRate);
            }
            this.setState({ hasBeenEdited: false, valid: false });
        };
    }
    update() {
        return () => {
            const accessorialRate = this.state.accessorialRate;
            if (accessorialRate) {
                accessorialRate.is_ready = RatesValidator(this.state.accessorialRate, Types);
                Store.reset();
                updateAccessorialRate(accessorialRate);
            }
            this.setState({ accessorialRate: accessorialRate, hasBeenEdited: false, valid: false });
        };
    }
    onAccessorialRateChange() {
        return (updatedAccessorialRate, edited, valid) => {
            this.setState({ accessorialRate: updatedAccessorialRate, hasBeenEdited: edited, valid: valid });
        };
    }
    render() {
        const newAccessorialRateMode = (!this.state.accessorialRate || !this.state.accessorialRate._id);
        const disableSaveButton = !(this.state.hasBeenEdited && this.state.valid);
        return (React.createElement(Modal, Object.assign({}, this.props, { onHide: this.close(), enforceFocus: false }),
            React.createElement(Modal.Header, { closeButton: true }),
            React.createElement(Modal.Body, null,
                React.createElement(AccessorialRatesEditor, { accessorialRate: this.state.accessorialRate, onChange: this.onAccessorialRateChange() })),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { onClick: this.close() }, "Close"),
                "\u00A0",
                React.createElement("span", null,
                    React.createElement(Button, { onClick: (newAccessorialRateMode) ? this.save() : this.update(), bsStyle: "primary", disabled: disableSaveButton }, (newAccessorialRateMode) ? 'Save' : 'Save Changes')))));
    }
}
